<template>
  <svg :class="className" :width="width" :height="height" :viewBox="viewBox" :fill="fill" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M5.81132 0.0584937C4.16725 0.237456 2.20513 1.08287 0.759434 2.2351L0 2.8404V4.01746V5.19464L0.891509 4.29798C2.02815 3.15474 3.08066 2.469 4.39957 2.01229C6.42692 1.3103 8.582 1.42231 10.4802 2.32847C11.5147 2.82244 12.8113 3.78197 12.8113 4.05378C12.8113 4.14834 12.6666 4.36178 12.4896 4.52806L12.168 4.83025L11.532 4.30089C10.196 3.18842 8.76875 2.68904 6.93396 2.69195C4.90713 2.69498 3.26675 3.43593 1.62598 5.08951L0.733547 5.98881L1.62598 6.88812C3.25025 8.52493 4.90898 9.28132 6.88708 9.2873C9.23934 9.29427 11.3726 8.17176 13.3726 5.87431L14 5.1537V3.99712V2.8404L13.2406 2.2351C12.3467 1.52268 10.7958 0.690739 9.77359 0.375343C8.91998 0.111984 6.84455 -0.0540346 5.81132 0.0584937ZM6.78709 4.27646C6.11417 4.53083 6.47408 5.58797 7.17381 5.41244C7.5283 5.32342 7.77277 4.8247 7.59936 4.54417C7.44377 4.29231 7.07053 4.16921 6.78709 4.27646ZM9.20394 5.13561C8.97387 6.55397 7.4686 7.41034 6.16409 6.86527C5.60291 6.6307 5.06166 5.97798 4.88521 5.32249C4.80781 5.03523 4.69753 4.80014 4.64021 4.80014C4.48449 4.80014 3.35419 5.56842 3.15264 5.81144C3.00155 5.99344 3.04077 6.07585 3.43687 6.40881C4.83251 7.58257 6.92604 8.0068 8.56998 7.44878C9.40853 7.16415 10.6199 6.47195 10.9225 6.10438C11.0514 5.94761 11.0024 5.85053 10.6584 5.58057C10.4259 5.39831 10.0207 5.11831 9.75787 4.95849L9.27989 4.66793L9.20394 5.13561ZM0 7.94551V9.13723L0.759434 9.74253C4.49796 12.7222 9.50204 12.7222 13.2406 9.74253L14 9.13723V8.00363V6.87002L13.1085 7.73063C12.0507 8.75197 11.1 9.37946 9.83962 9.88821C9.04902 10.2074 8.68542 10.2695 7.33019 10.3164C5.91355 10.3655 5.63632 10.3363 4.718 10.0419C3.30453 9.5888 2.01296 8.7867 0.921226 7.68427L0 6.7538V7.94551Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: 'OverviewIcon',
  props: {
    className: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '14',
    },
    height: {
      type: String,
      default: '12',
    },
    viewBox: {
      type: String,
      default: '0 0 14 12',
    },
    fill: {
      type: String,
      default: 'none',
    },
  },
};
</script>
